import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Roles } from '@shared/enums/roles.enum';
import { AuthGuard } from './guards/auth.guard';
import { KeycloakService } from 'keycloak-angular';
import { NoPermissionComponent } from './components/no-permission/no-permission.component';
import { NavigationResolver } from 'src/services/navigation/navigation-resolver';

const orderRoles = [Roles.Admin, Roles.User, Roles.QWiz, Roles.Hedgehog];
const adminRoles = [Roles.Admin, Roles.QWiz, Roles.Hedgehog];

const routes: Routes = [
	{
		// Startseite = Bestellungen: für alle Rollen erreichbar
		path: '',
		redirectTo: 'orders',
		pathMatch: 'full',
		canMatch: [AuthGuard],
		data: {roles: orderRoles},
		resolve: {nav: NavigationResolver} // resolve-data is ignored - it is just to enforce "load navigation"
	}, {
		path: 'orders',
		loadChildren: () => import('../modules/orders/orders.module').then(m => m.OrdersModule),
		canMatch: [AuthGuard],
		data: {roles: orderRoles},
		resolve: {nav: NavigationResolver} // resolve-data is ignored - it is just to enforce "load navigation"
	}, {
		// Alt-Pfade: bestehende Links/Lesezeichen auf /orders umbiegen
		path: 'products/order-review',
		redirectTo: 'orders',
		pathMatch: 'full',
		canMatch: [AuthGuard],
		data: {roles: orderRoles}
	}, {
		path: 'products/order-review/:orderId',
		redirectTo: 'orders/:orderId',
		pathMatch: 'full',
		canMatch: [AuthGuard],
		data: {roles: orderRoles}
	}, {
		path: 'sales',
		loadChildren: () => import('../modules/sales/sales.module').then(m => m.SalesModule),
		canMatch: [AuthGuard],
		data: {roles: adminRoles},
		resolve: {nav: NavigationResolver} // resolve-data is ignored - it is just to enforce "load navigation"
	}, {
		path: 'products',
		loadChildren: () => import('../modules/products/products.module').then(m => m.ProductsModule),
		canMatch: [AuthGuard],
		data: {roles: adminRoles},
		resolve: {nav: NavigationResolver} // resolve-data is ignored - it is just to enforce "load navigation"
	}, {
		path: 'admin',
		loadChildren: () => import('../modules/admin/admin.module').then(m => m.AdminModule),
		canMatch: [AuthGuard],
		data: {roles: adminRoles},
		resolve: {nav: NavigationResolver} // resolve-data is ignored - it is just to enforce "load navigation"
	},
	{
		path: 'no-permission',
		component: NoPermissionComponent
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
	providers: [AuthGuard, KeycloakService]
})
export class AppRoutingModule {
}
